import { render, staticRenderFns } from "./AboveTheFold.vue?vue&type=template&id=82e4f2b0&scoped=true"
import script from "./AboveTheFold.vue?vue&type=script&lang=js"
export * from "./AboveTheFold.vue?vue&type=script&lang=js"
import style0 from "./AboveTheFold.vue?vue&type=style&index=0&id=82e4f2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e4f2b0",
  null
  
)

export default component.exports